import React from 'react';
import { Select } from 'antd';
import { Input } from '@progress/kendo-react-inputs';
import { Button } from '@progress/kendo-react-buttons'
import services from '../../../services'

const { Option } = Select;

class BoletimWizardTitularModalForm extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         popUpForm: '',
         data: [],
         entityDataList: [],
         searchValid: 0,
         optionsEntityList: '',
         entity_list_object: {},
         defaultSelection: "",
         error:null,
         outrosNoExplorerTitular: null,
         outrosNoPropertyTitular: null,
         parcelExplorerDisable : false,
         parcelPropertyDisable : false,
         insertBecasueNoEntryExplorer: false,
         insertBecasueNoEntryProperty: false
         
      }
   }

   /* Esta é a primeira etapa após o construxctor para carregar este componente  */

   componentDidMount() {
      //console.log("---------------------------- did MOUNT block")
      console.log("onmount",this.props.parcelData);
      let parcelExplorerDisable = false
      let parcelPropertyDisable = false
      let insertBecasueNoEntryProperty = false
      let insertBecasueNoEntryExplorer = false
      let parcelData = this.props.parcelData;
      if (parcelData) {
         if (!Array.isArray(parcelData)) {
            parcelData = [parcelData]
         }
         if(parcelData && parcelData.length === 0){
            if(this.props.tab === "boletimExplorador"){
               insertBecasueNoEntryExplorer = true
               parcelExplorerDisable = false
            }
            else if(this.props.tab === 'boletimProprietario'){
               insertBecasueNoEntryProperty = true
               parcelPropertyDisable = false
            }
         }
         if(this.props.tab === "boletimExplorador" && !insertBecasueNoEntryExplorer){
            parcelExplorerDisable = true
            insertBecasueNoEntryExplorer = true
         }
         else if(this.props.tab === 'boletimProprietario' && !insertBecasueNoEntryProperty){
            parcelPropertyDisable = true
            insertBecasueNoEntryProperty = true
         }
            
      }
      this.setState({
         data: parcelData,
         optionsEntityList:'',
         parcelExplorerDisable,
         parcelPropertyDisable,
         defaultSelection : "",
         insertBecasueNoEntryProperty,
         insertBecasueNoEntryExplorer,
         outrosNoExplorerTitular: this.props.outrosNoExplorer,
         outrosNoPropertyTitular: this.props.outrosNoProperty
         //entity_list_object: this.props.entity_list_object
      },()=>this.getEntityListObject())
   }

   componentDidUpdate(prevProps) {
      //console.log("================================== did UPDATE block")
      if (prevProps.date !== this.props.date) {
         console.log("================================== did UPDATE block")
         let parcelExplorerDisable = false
         let parcelPropertyDisable = false
         let insertBecasueNoEntryProperty = false
         let insertBecasueNoEntryExplorer = false
         let parcelData = this.props.parcelData;
         if (parcelData) {
            
            if (!Array.isArray(parcelData)) {
               parcelData = [parcelData]
            }
            
            if(parcelData && parcelData.length === 0){
               console.log("onUpdate",this.props.parcelData);
               if(this.props.tab === "boletimExplorador"){
                  insertBecasueNoEntryExplorer = true
                  parcelExplorerDisable = false
               }
               else if(this.props.tab === 'boletimProprietario'){
                  insertBecasueNoEntryProperty = true
                  parcelPropertyDisable = false
               }
            }

            if(this.props.tab === "boletimExplorador" && !insertBecasueNoEntryExplorer){
               parcelExplorerDisable = true
               insertBecasueNoEntryExplorer = true
            }
            else if(this.props.tab === 'boletimProprietario' && !insertBecasueNoEntryProperty){
               parcelPropertyDisable = true
               insertBecasueNoEntryProperty = true
            }
         }
         this.setState({
            data: parcelData,
            defaultSelection: null,
            optionsEntityList:'',
            parcelExplorerDisable,
            parcelPropertyDisable,
            insertBecasueNoEntryProperty,
            insertBecasueNoEntryExplorer,
            outrosNoExplorerTitular: this.props.outrosNoExplorer,
            outrosNoPropertyTitular: this.props.outrosNoProperty
            //entity_list_object: this.props.entity_list_object
         },()=>this.getEntityListObject())
      }
   }

   componentWillUnmount(){
      console.log("component unmoount")
   }

   getEntityListObject = async () => {
      let entityListObject = {}
      if(this.props.tab !== 'parcel' && this.state.data && this.state.data.length > 0){
         for (let i = 0; i < this.state.data.length; i++) {
            const element = this.state.data[i];
            
            let res = await services.EntityList.getEntityList('parcel', null,element.nif);
            if(res){
               entityListObject = {...entityListObject,...res.entity_row}
            }
         }

         this.setState({entity_list_object : entityListObject})
      }
   }

   addDatatoMainData = (setdata) => {
      let data = [];
      let alreadySet = false
      //console.log("After for submit",setdata,this.state.data);
      if (this.state.data) {
         data = [...this.state.data]
      }
      data.map((_r, i) => {
         if (_r.nif && ((_r.nif).trim() === setdata.nif)) {
            alreadySet = true;
            if (Object.keys(setdata).length > 1)
               data[i] = setdata;
         }
      })
      if (!alreadySet) {
         data.push(setdata)
      }
      //console.log("After form submit",data);
      this.setState({
         data
      } //, () => this.props.getPopUpFormState(this.state.data, this.props.tab)
      )
   }

   insertDataToRightPanel = () => this.props.getPopUpFormState(this.state.data, this.props.tab)

   handleFechar = () => {
      try {
         this.props.closePopup()
         this.setState({
            data: this.props.parcelData
         })
         
      } catch (error) {
         this.setState({error})
      }
   }

   handleDeleteEntity = () => {
      try {
         
         
         if(this.props.tab === "boletimExplorador") {
            //this.props.__updateOutrosNoExplora(null)
            this.setState({
               parcelExplorerDisable : false,
               outrosNoExplorerTitular: null,
               insertBecasueNoEntryExplorer : true
            })

         }
         
         else 
            this.setState({
               parcelPropertyDisable : false,
               insertBecasueNoEntryProperty: true,
               outrosNoPropertyTitular: null,
            })
         this.setState({
            data : [],
            entityDataList: [],
            optionsEntityList: '',
            entity_list_object: {}
         }, () => {
            //this.props.editState();
         })
      } catch (error) {
         this.setState({error})
      }
   }

   getPopUpFormState = (data, tab, outrosNoExplorerTitular, outrosNoPropertyTitular) => {
      if(data.length > 0){
         let dataObject = data[0];
         let newData = []
         if(tab === 'boletimExplorador') {
            newData = [{...dataObject, ['nrOutrosExploradores'] : outrosNoExplorerTitular}]
         } else {
            newData = [{...dataObject, ['nrOutrosProprietarios'] : outrosNoPropertyTitular}]
         }
         this.props.getPopUpFormState(newData, tab, outrosNoExplorerTitular, outrosNoPropertyTitular)
      }
      else {
         this.props.getPopUpFormState(data, tab, outrosNoExplorerTitular, outrosNoPropertyTitular)
      }
      this.props.closePopup()
      
   }

   handleSelect = async (value) => {
      try {
         await this.entitypermissoncheck(value);
      } catch (error) {
         this.setState({error})
      }
   }

   handleInputChange = (e) => {
      
      if(!isNaN(+e.target.value)){
         if(this.props.tab === "boletimExplorador") {
            this.setState({
               outrosNoExplorerTitular : +e.target.value
            })
         }
         else {
         this.setState({
            outrosNoPropertyTitular : +e.target.value
         })
         }
      }
         
      // this.setState({[e.target.name] : +e.target.value})
   }

   entitypermissoncheck = async (nif) => {
      let id = this.state.entity_list_object[nif].codEntidade;
      let data = {
         id: Number(id),
         modulename: "parcel"
      }
      let res = await services.apiCall.requestApi('/Entity/CheckPermission', data, 'post');
      if (res) {
         let newEntityId = {
            entnum: nif,
            nome: this.state.entity_list_object[nif].nome,
            nif: this.state.entity_list_object[nif].nif,
            nifap: this.state.entity_list_object[nif].nifap
         }
         
         if(this.props.tab === "boletimExplorador"){
            this.setState({
               parcelExplorerDisable : true,
               insertBecasueNoEntryExplorer: false
            },()=>this.addDatatoMainData(newEntityId))
         }
         else {
            this.setState({
               parcelPropertyDisable : true,
               insertBecasueNoEntryProperty: false
            },()=>this.addDatatoMainData(newEntityId))
         }
            
      }
   }


   entityListOption = () => {
      //console.log("ENTITYLIST",this.state.entityDataList)
      let optionsEntityList = (
         this.state.entityDataList.map((_r, i) => (
            <Option value={_r.nif}>{_r.nome}<br />{_r.nifap}</Option>
         ))
      )

      this.setState({
         optionsEntityList
      })
   }


   handleParcelHolder = (row) => {
      try {
         this.props.getPopUpFormState(row, this.props.tab);
         this.props.closePopup()
      } catch (error) {
         this.setState({error})
      }
   }

   onSearch = async (e) => {
      try {
         if (e.length >= 3) {

            let res = await services.EntityList.getEntityList('parcel', e);
            if (res) {
               let entityListObject = {...this.state.entity_list_object, ...res.entity_row }
               this.setState({
                  entityDataList: res.entityList,
                  entity_list_object: entityListObject,
                  searchValid: e.length,
               }, () => this.entityListOption())
            }
         } else {
            this.setState({
               searchValid: 0
            })
         }
         //this.setState({ defaultSelection: e })
      } catch (error) {
         this.setState({error})
      }
   }


   render() {
      if(this.state.error){
         throw this.state.error
      }
        const tabLabel = `Nº Outros ${this.props.tab === 'boletimExplorador' ? "Exploradores" : "Proprietários"}`;
      return (
         <div className="modal-content">
            <div className="modal-header">
               <h4 className="modal-title pl-0">Associar  {
                  this.props.tab === 'boletimProprietario' ? 'Proprietário' : 'Explorador'
               }
               </h4>
               {/* <button type="button" className="btn btn-success btn-sm text-uppercase mr-3">Guardar</button>  */
               }
               <Button primary={true} onClick={() => this.getPopUpFormState(this.state.data, this.props.tab, this.state.outrosNoExplorerTitular, this.state.outrosNoPropertyTitular)} className="remoove btn-ivdp-primary cursor-pointer mr-2">Inserir</Button>
               <Button primary={true} onClick={() => this.handleFechar() } className="remoove btn-ivdp-primary cursor-pointer mr-2">Fechar</Button>
            </div>
            <div className="modal-body">
            <label>Nome/NIF</label>
               <div className="form-group position-relative associar">
            
                  <div className="input-box active-grey mt-0">
                   
                     {/* <label className="input-label">Pesquisar por Nº ou Nome</label>  */
                     }
                     {/* <input type="text" name="searchKey" value={this.state.searchKey} onChange={this.handleChange} className="input-1" placeholder="Pesquisar por Nº ou Nome"/>  */
                     }

                     <Select
                        onChange={this.handleSelect}
                        showSearch
                        disabled={this.props.tab === "boletimExplorador" ? this.state.parcelExplorerDisable : this.state.parcelPropertyDisable}
                        onSearch={this.onSearch}
                        style={{ width: "100%" }}
                        value={this.state.defaultSelection || ""}
                        //defaultValue={""}
                        placeholder="Pesquisar por Nº ou Nome"
                        optionFilterProp='children'
                        notFoundContent="Entidade não encontrada, refina os critérios de pesquisa"
                     >
                        
                        {
                           this.state.searchValid >= 3 &&
                           this.state.optionsEntityList
                        }
                        
                     </Select>

                  </div>
                  <span className="cursor-pointer search-icon">
                     <i className="fas fa-search"></i>
                  </span>
                  {
                     this.state.data && this.state.entity_list_object ?
                     this.state.data.map((_r, i) => (
                        _r.nif && this.state.entity_list_object[(_r.nif).trim()] &&
                        <div className="listing mt-0" key={i}>
                           
                              <div className="associar-listing">
                                 <div className="d-flex justify-content-between">
                                    
                                    <div className="select-left">
                                       <label>NIF</label>
                                       <div className="border-left">
                                       <p className="small font-14 m-0 d-md-flex">{this.state.entity_list_object[(_r.nif).trim()] && this.state.entity_list_object[(_r.nif).trim()].nifap}</p>
                                       </div>
                                       
                                    </div>
                                    
                                    <div className="select-right">
                                    <label>Nome</label>
                                       <div className="border-right">
                                      
                                          <div className="position-relative">
                                          <p className="top-head m-0">{this.state.entity_list_object[(_r.nif).trim()] && this.state.entity_list_object[(_r.nif).trim()].nome}</p> 
                                          <span className="close-icon" data-toggle="modal" data-target='#left-explor-popup' onClick={() => this.handleDeleteEntity()}><i className="fas fa-times"></i></span>
                                       </div>
                                       </div>
                                    </div>

                                    <div className="ml-auto">
                                       
                                    </div>
                                    
                                 </div>
                              
                              </div>
                              
                           
                           <div className="mt-2">
                              <p className="my-4">Indique o número de outros {this.props.tab === 'boletimExplorador' ? "exploradores" : "proprietários"} associados ao boletim. Deixe vazio, caso não se verifique esta situação</p>
                              <div>
                                 <p className="mt-3 text-left ml-1">
                                    <Input
                                       type="text"
                                       name="outrosNo"
                                       value={this.props.tab === "boletimExplorador" ? this.state.outrosNoExplorerTitular : this.state.outrosNoPropertyTitular ||""}
                                       className="input-1"
                                       style={{height:"65px", width:"50%"}}
                                       label={tabLabel}
                                       onChange={(e) => this.handleInputChange(e)}
                                    />
                                 </p>
                              </div>
                           </div>
                        </div>
                     ))
                     
                     :  
                     
                     this.props.tab === 'boletimProprietario' ? 
                     <div className="searct-found">
                        <img className="img-fluid" src="imgs/search-large-icon.png" />
                        <p className="font-14">Sem proprietários</p>
                        <h5>Associe pelo menos um proprietário ao registo</h5>
                     </div>

                     :

                     this.props.tab === 'boletimExplorador' &&
                     <div className="searct-found">
                        <img className="img-fluid" src="imgs/search-large-icon.png" />
                        <p className="font-14">Sem exploradores</p>
                        <h5>Associe pelo menos um explorador ao registo </h5>
                     </div>
                     
                  }
                  
               </div>
               <div className="modal left-popup" id="left-explor-popup">
                  <div className="modal-dialog modal-sm">
                     {
                        this.state.popUpForm
                     }
                  </div>
               </div>
            </div>
         </div>

      )
   }
}

export default BoletimWizardTitularModalForm
